import { type FC, useRef } from "react";

import { DEPRECATED_useTooltip as useTooltip } from "../../hooks/DEPRECATED_useTooltip.ts";
import { formatDateTimeFromISO, toTimeAgo } from "../../utils/date/_mod.ts";
import { isTimeAllZero } from "../../utils/date/isTimeAllZero.js";
import { Tooltip } from "../Tooltip/Tooltip.tsx";

export interface TimeAgoProps {
  dateTimeISO: string;
  hideTime?: boolean;
}

export const TimeAgo: FC<TimeAgoProps> = (props) => {
  const triggerRef = useRef<HTMLSpanElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const { state, tooltipProps, arrowProps, triggerProps } = useTooltip(triggerRef, tooltipRef, { offset: 7 });

  const hideTime = props.hideTime || isTimeAllZero(props.dateTimeISO);

  return (
    <>
      <span {...triggerProps} ref={triggerRef} style={{ cursor: "default", width: "fit-content" }} data-testid={"date"}>
        {toTimeAgo(props.dateTimeISO, hideTime)}
      </span>
      {!!state.isOpen && (
        <Tooltip
          ref={tooltipRef}
          domProps={tooltipProps}
          arrowProps={arrowProps}
          content={formatDateTimeFromISO(props.dateTimeISO, { hideTime: hideTime })}
        />
      )}
    </>
  );
};
